import { Loadable } from '@/components/loaders';
import RouteConstants from '@/features/router/RouteConstants';
import { useWorkspace } from '@/features/workspaces/hooks/useWorkspace';
import { PageLayout } from '@/global/components';
import { useDelayedBoolean } from '@/hooks/useDelayedBoolean';
import { BreadcrumbItem, Breadcrumbs } from '@/lib/Breadcrumbs';
import { useGetCampaignQuery } from '@/services/endpoints/campaigns';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { CampaignDetailHeader } from './CampaignDetailHeader';
import { CampaignDetailsContent } from './CampaignDetailsContent';
import ErrorBoundary from '@/components/ErrorBoundary';

const breadcrumbs: BreadcrumbItem[] = [
  {
    label: 'campaign:listPageBreadcrumb',
    path: RouteConstants.campaigns,
  },
  {
    label: 'campaign:detailPageBreadcrumb',
  },
];

export const CampaignDetails: FC = () => {
  const workspace = useWorkspace();

  const { id: campaignId } = useParams<{ id: string }>();

  const {
    data: campaign,
    isFetching,
    isUninitialized,
  } = useGetCampaignQuery({
    campaignId,
    workspaceId: workspace.id,
  });

  const isFetchingDelayed = useDelayedBoolean(isFetching, 400);

  const shouldShowLoading = isFetching || isFetchingDelayed || isUninitialized;

  return (
    <Loadable isLoading={shouldShowLoading}>
      <PageLayout className='gap-0 bg-secondary-background px-0'>
        <div className='bg-white-100 px-8'>
          <Breadcrumbs className='border-b border-quaternary-200 pb-4' items={breadcrumbs} />
        </div>
        <CampaignDetailHeader campaign={campaign} />
        <ErrorBoundary>
          <CampaignDetailsContent />
        </ErrorBoundary>
      </PageLayout>
    </Loadable>
  );
};
